import { Five9ChatConfig } from "../five9Chat";

export const defaultChatConfig: Five9ChatConfig = {
  "rootUrl": "https://app.five9.com/consoles/",
  "type": "chat",
  "title": "Young Living Live Help - US",
  "tenant": "Young Living Essential Oils",
  "profiles": "US English Chat",
  "showProfiles": true,
  "autostart": true,
  "profileLabel": "Chat",
  "theme": "https://five9-chat.ec.youngliving.com/yl-five9-theme.css",
  "surveyOptions": {
    "showComment": true,
    "requireComment": false
  },
  "fields": {
    "name": {
      "value": "",
      "show": true
    },
    "email": {
      "value": "",
      "show": true
    },
    "Custom.MemberID": {
      "value": "",
      "show": true,
      "label": "Member Number",
      "required": false
    },
    "Custom.MemberPIN": {
      "value": "",
      "show": true,
      "label": "PIN",
      "required": false
    }
  },
  "playSoundOnMessage": true,
  "allowCustomerToControlSoundPlay": true,
  "showEmailButton": false,
  "hideDuringAfterHours": false,
  "useBusinessHours": true,
  "showPrintButton": true,
  "allowUsabilityMenu": true,
  "enableCallback": false,
  "callbackList": "",
  "allowRequestLiveAgent": false
};
